import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
export class CircuitNotification extends Component {
  constructor(props) {
    super(props);  
    this.state={
      show:false,
      acceptConf:false,
    }
  }

  handelAcceptConfirmation = () => {
    this.props.handleModal()   
  }

  render(){
    
    return(
      <>
      
      <Modal
        show={this.props.show}
        onHide={this.props.handleModal}
        backdrop="static"
        keyboard={false}
        className="custom-footer-information custom-column-modal-container modal-rematch inventory-confirmation-wrapper text-align-left"
      >
        <Modal.Header closeButton>
          <Modal.Title>Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>        
            This circuit is still under an order workflow, users are restricted to save
            any changes
                </Modal.Body>
                <Modal.Footer>
            <Button variant="primary" onClick={this.handelAcceptConfirmation}>OK</Button>                   
        </Modal.Footer> 
      </Modal>

      </>
    );
  }
}
